import { render } from "./UserVideos.vue?vue&type=template&id=a4410022"
import script from "./UserVideos.vue?vue&type=script&lang=js"
export * from "./UserVideos.vue?vue&type=script&lang=js"

import "./UserVideos.vue?vue&type=style&index=0&id=a4410022&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__